import React from "react";
import PaginationModel from "../../common/Store/models/Pagination";
import Pagination from "~/common/Pagination";
import navigateToPageNumberHref from "./navigateToPageNumberHref";

interface Props {
  paging: PaginationModel;
  currentUrl: string;
}

const PaginationComponent = ({ paging, currentUrl }: Props) => {
  return (
    <Pagination
      currentPage={paging.currentPage}
      total={paging.totalNumberOfItems}
      pageSize={paging.pageSize}
      createHREF={(page: number) => navigateToPageNumberHref(currentUrl, page)}
    />
  );
};

export default PaginationComponent;
